export interface CarrierDefinition {
  id: string; // ex: 'colissimo', 'chronopost', 'dhl', 'dpd'
  name: string;
  logoPath: string; // chemin dans /public
  trackingUrlTemplate: string; // URL de suivi avec {trackingNumber} comme placeholder
}

export const CARRIERS: CarrierDefinition[] = [
  {
    id: "colissimo",
    name: "Colissimo",
    logoPath: "/colissimo-logo.png",
    trackingUrlTemplate:
      "https://www.laposte.fr/outils/suivre-vos-envois?code={trackingNumber}",
  },
  {
    id: "chronopost",
    name: "Chronopost",
    logoPath: "/chronopost-logo.png",
    trackingUrlTemplate:
      "https://www.chronopost.fr/fr/suivi-colis?listeNumerosLT={trackingNumber}",
  },
  {
    id: "dhl",
    name: "DHL Express",
    logoPath: "/dhl-express.png",
    trackingUrlTemplate:
      "https://www.dhl.com/global-en/home/tracking.html?tracking-id={trackingNumber}",
  },
  {
    id: "dpd",
    name: "DPD",
    logoPath: "/dpd-logo.png",
    trackingUrlTemplate:
      "https://www.dpd.fr/trace/{trackingNumber}",
  },
  {
    id: "fedex",
    name: "FedEx",
    logoPath: "/fedex-logo.png",
    trackingUrlTemplate:
      "https://www.fedex.com/fedextrack/?tracknumbers={trackingNumber}",
  },
  {
    id: "ups",
    name: "UPS",
    logoPath: "/ups-logo.png",
    trackingUrlTemplate:
      "https://www.ups.com/track?tracknum={trackingNumber}",
  },
];
